import React from "react";
import * as M from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { useStyles } from "../theme";

import * as Icon from "react-feather";

const StartObhEnBs = props => {
  const { $user, $locale } = props.store;
  const classes = useStyles();
  const [moreInfo, setMoreInfo] = React.useState({ ouderbetrokkenheid: false, bredeschool: false });

  return (
    <div className="lg:grid grid-cols-12">
      <aside className="col-span-4 p-8 flex flex-col justify-between">
        <h5 className="mb-8">
          <b>Een instrument</b> dat onderwijsprofessionals in staat stelt hun school in kaart te
          brengen.
        </h5>
        <div>
          Voor meer vragen over dit instrument kan u terecht bij:
          <br />
          <b>Onderwijscentrum Gent</b>
          <br />
          <b>Woodrow Wilsonplein 5</b>
          <br />
          <b>9000 GENT</b>
          <br />
          <b>+32 9 323 50 50</b>
          <br />
          <a
            href="mailto:Onderwijscentrum@stad.gent"
            target="_blank"
            rel="noopener noreferrer"
            className="color-primary"
          >
            E-mail
          </a>
          <br />
          <a
            href="https://stad.gent/onderwijscentrum-gent"
            target="_blank"
            className="color-primary"
            rel="noopener noreferrer"
          >
            Website
          </a>
        </div>
      </aside>
      <section className="lg:col-span-8 ">
        <div className="flex items-center justify-center">
          <div className="lg:w-8/12 m-auto h-full p-8 bg-white ">
            <div>
              <h3 className="color-primary mb-8 flex">Partnerschap Ouders en School</h3>
              <div className="mb-8">
                Breng in kaart hoe de samenwerking, de communicatie en het partnerschap tussen
                ouders en school verloopt.
              </div>
            </div>
            <M.Box mb={1}>
              <M.Button
                fullWidth
                variant="outlined"
                classes={{ root: classes.navButtonLabel }}
                onClick={() => setMoreInfo({ ouderbetrokkenheid: true, bredeschool: false })}
                startIcon={<Icon.Info />}
              >
                Meer informatie
              </M.Button>
            </M.Box>
            <M.Button
              fullWidth
              onClick={e => {
                $user.change("registerForCluster", "ouderbetrokkenheid");
                $user.change("enableRegister", true);
              }}
              classes={{ root: classes.navButtonLabel }}
              startIcon={<Icon.Play />}
              label="Registreer"
            >
              Registreer
            </M.Button>
          </div>
        </div>
        <M.Dialog
          open={moreInfo.ouderbetrokkenheid}
          onClose={() => setMoreInfo({ ouderbetrokkenheid: false, bredeschool: false })}
        >
          <M.DialogTitle id="form-dialog-title">Partnerschap tussen ouders en school</M.DialogTitle>
          <M.DialogContent>
            <p>
              Ouders en schoolteams hebben één zorg gemeenschappelijk: de zorg om het welbevinden en
              de ontwikkeling van elk kind. In een goed partnerschap kunnen ouders en schoolteams
              elkaar verrijken en versterken om het kind zo goed mogelijk te ondersteunen.
            </p>
            <p>
              De ouderbarometer is een instrument waarmee je als het ware ‘een foto neemt’ van de
              wijze waarop de samenwerking , de communicatie en het partnerschap tussen ouders en
              school verloopt. Het is géén meetinstrument waarbij je kunt nagaan of je een bepaald
              niveau van samenwerking school-gezin hebt behaalt. Het geeft wél een beeld van hoe
              ouders en team op dat moment tegen de samenwerking en het partnerschap aankijken.
            </p>
            <p>
              <b>De barometer concreet</b>
            </p>
            De barometer bestaat uit: <br />
            <ul>
              <li>Een vragenlijst voor ouders</li> <li>Een vragenlijst voor leerkrachten</li>
              <li>Een vragenlijst voor het beleidsteam op school</li>
            </ul>
            <p>
              Dit voor zowel de basisschool als de secundaire school. Voor de ouders werd de
              vragenlijst ook in 11 verschillende talen voorzien. Deze vragensets worden als geheel
              afgenomen. Je kan ook zelf vragen toevoegen.
            </p>
            <p>
              Na de afname krijgt u een overzichtelijk rapport met sterktes en groeimogelijkheden
              waarmee u dan verder aan de slag kan.
            </p>
            Wilt u meer info over het partnerschap tussen ouders en scholen en hoe het
            Onderwijscentrum Gent hierin ondersteunt? Neem dan een kijkje op onze{" "}
            <a
              href="https://stad.gent/onderwijscentrum-gent/ouderbetrokkenheid"
              target="_blank"
              rel="noopener noreferrer"
            >
              website
            </a>
          </M.DialogContent>
          <M.DialogActions>
            <M.Button
              variant="text"
              onClose={() => setMoreInfo({ ouderbetrokkenheid: false, bredeschool: false })}
            >
              {$locale.t("cancel")}
            </M.Button>
            <M.Button
              onClick={() => {
                setMoreInfo({ ouderbetrokkenheid: false, bredeschool: false });
                $user.change("registerForCluster", "bredeschool");
              }}
            >
              OK
            </M.Button>
          </M.DialogActions>
        </M.Dialog>
      </section>
    </div>
  );
};

export default inject("store")(observer(StartObhEnBs));
